import React, { useEffect, useContext } from "react";
import { AppSettings } from "../../config/app-settings.js";
import Title from "../../components/Title.tsx";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader.tsx";
import { setLoading, setTotal, setVacantes } from "../../store/slices/vacantesSlice.ts";
import { notification } from "../../utils/Notifications.tsx";
import { getUnfilledPositionsPaginated } from "../../services/partner.service.ts";
import { RootState } from "../../store/index.ts";
import FilterButtonsVacantes from "../../components/vacantes/FilterButtonsVacantes.tsx";
import TableVacantesV2 from "../../components/vacantes/TableVacantesV2.tsx";

function VacanciesV2() {
  const context = useContext(AppSettings);

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-0");
    context.handleSetAppTopMenu(true);

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
      context.handleSetAppTopMenu(false);
    };
  }, []);

  const dispatch = useDispatch();
  const { page, limit, query, sortBy, defaultSort, loading } = useSelector(
    (state: RootState) => state.vacantes
  );

  const fetchVacantesV2 = React.useCallback(async () => {
    dispatch(setLoading(true));
    try {
      const offset = page === 0 ? 0 : page * limit;
      const base = (query || "").replace(/^&/, "").trim();
      const queryToSend =
        (base ? base + "&" : "") +
        `sort=${sortBy}&order=${defaultSort}&limit=${limit}&offset=${offset}`;
      const response = await getUnfilledPositionsPaginated(queryToSend);
      dispatch(setVacantes(response.data || []));
      dispatch(setTotal(response.total ?? 0));
    } catch (error: any) {
      notification("Error", error?.message ?? "Error al cargar puestos sin cubrir", "danger");
      dispatch(setVacantes([]));
      dispatch(setTotal(0));
    } finally {
      dispatch(setLoading(false));
    }
  }, [dispatch, page, limit, query, sortBy, defaultSort]);

  useEffect(() => {
    fetchVacantesV2();
  }, [page, limit, query, sortBy, defaultSort]);

  return (
    <>
      <Title
        baseTitle="Vacantes"
        basePath="/vacantes/v2"
        title="Vacantes"
      />
      <FilterButtonsVacantes />
      <div className="card border-0 m-4">
        <div className="tab-pane fade show active" id="sucursal">
          <div className="card-body">
            <TableVacantesV2 fetchVacantesV2={fetchVacantesV2} />
          </div>
        </div>
      </div>
      <div className="h-75px" />
      <div
        className="w-1000px h-75px"
        style={{
          backgroundImage: "url(../../../assets/img/footer/footer-chili.png)",
          backgroundRepeat: "repeat-x",
          position: "fixed",
          bottom: "0",
          left: "0",
          width: "100%",
          zIndex: 1,
        }}
      />
      <Loader isLoading={loading} />
    </>
  );
}

export default VacanciesV2;
